import { BaseObject } from "@adgate/common/types/base-object.type";

export class CommercialType extends BaseObject
{
    public static USAGE_TV:number                   = 1;
    public static USAGE_STREAMING:number               = 2;
    public static USAGE_PRODUCTIONORDER:number      = 3;
    public static USAGE_PRODUCTIONVERSION:number    = 4;

    public static SPOTPOLITICAL:number              = 10;
    public static PRODUCTIONSPOT:number             = 80;

    shortDescription!: string;
    requireMedianfo!: boolean;
    mediainfoProfiles!: string;

    constructor()
    {
        super();
    }
}